import React from 'react'
import styles from './init.scss'
import Button from 'src/components/common/Button'
import { PurchaseWorkflowNode } from 'src/actions/stripeCheckout'
import SendInviteBg from 'src/assets/send-invite-bg.jpg'
import CheckoutFrame from '../components/CheckoutFrame'
import { PlanSlugs } from 'src/services/stripe_checkout_configs'
import PropTypes from 'prop-types'

class Init extends React.Component {
  render() {
    const { user, currentSub, params } = this.props

    let isMembership = false
    let canUpgradePlan = false
    let isFreeTrailUsed = true
    if (currentSub) {
      isMembership = currentSub.plan.slug !== PlanSlugs.Free
      canUpgradePlan = currentSub.plan.slug !== PlanSlugs.PremiumAnnually &&
        isMembership
      isFreeTrailUsed = !user?.is_trial_available
    }

    const insufficientNumber = Number(params.requiredCredits)

    return <CheckoutFrame
      left={<>
        {<section className={styles['init-container']}>
          <div className={styles['action-description']}>
            <header>
              <h1>Unsent Invites</h1>
            </header>
            {isFreeTrailUsed || isMembership ? (<>
              <p>
                Looks like you need {insufficientNumber} more credits to finish sending your invites.
                {canUpgradePlan && <> <b>Upgrade</b> to send the remaining invites using Hobnob’s world-class automation.</>}
              </p>
              <p>
                You’ll be able purchase additional credits anytime you need.
              </p>
            </>) : (<>
              <p>Looks like you need {insufficientNumber} more credits to finish sending your invites.</p>
              <p><b>Redeem your FREE WEEK</b> of Hobnob’s plans to use our world-class automation.</p>
              <p>You’ll be able purchase additional credits anytime you need.</p>
            </>)}
          </div>
          <div className={styles['action-items']}>
            {isMembership && <>
              <Button className={styles['action-subscribe']} onClick={() => {
                this.props.goToCheckoutNode(PurchaseWorkflowNode.PurchaseCredits)
              }}>GET MORE SMART INVITES</Button>
              {canUpgradePlan && <Button className={styles['action-subscribe']} filled={false} onClick={() => {
                this.props.goToCheckoutNode(PurchaseWorkflowNode.UpgradePlan)
              }}>SEE UPGRADE OPTIONS</Button>}
            </>}
            {!isMembership && <>
              <Button className={styles['action-subscribe']} onClick={() => {
                this.props.goToCheckoutNode(PurchaseWorkflowNode.PurchasePlan)
              }}>
                {isFreeTrailUsed ? (
                  <>Subscribe</>
                ) : (
                  <>REDEEM YOUR FREE WEEK</>
                )}
              </Button>
            </>}
            <a onClick={() => {
              this.props.goToCheckoutNode(PurchaseWorkflowNode.SendInviteManually)
            }}>Send invites manually</a>
          </div>
        </section>}
      </>}
      right={<img className={styles['send-invite-bg']} alt="Unsent Invites" src={SendInviteBg} />}
    />
  }
}

Init.propTypes = {
  params: PropTypes.object,
  user: PropTypes.object,
  currentSub: PropTypes.object,
  goToCheckoutNode: PropTypes.func
}

export default Init
